module.exports = __webpack_public_path__ + "4a44913b1b8ef585f2f36923e0cd6825.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Cushion@2x.png
// module id = 319
// module chunks = 0